export default "__VITE_ASSET__DlW1I03Y__"